import React from 'react';
import content from '../content';

import { BannerWrapper } from './styles/BannerStyles';

const Banner = () => {
  const { banner: { header, subheader }} = content;
  
  return <BannerWrapper>
    <div className="inner">
      <header className="major">
        <h1>{header}</h1>
      </header>
      <div className="content">
        <p dangerouslySetInnerHTML={{ __html: subheader }}></p>
      </div>
    </div>
  </BannerWrapper>
  
};

export default Banner;